import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="sanitation-reports--filters"
export default class extends Controller {
  static targets = ["customDateRangeFields", "fieldSelect"];
  static values = {
    allCustomFields: Object,
  };

  connect() {
    this.toggleCustomDateRangeFields();

    // Initialize field select if form is already selected
    const formSelect = document.getElementById("q_sanitation_form_id_eq");
    if (formSelect && formSelect.value) {
      this.updateCustomFields(formSelect.value);
    }
  }

  toggleCustomDateRangeFields() {
    const dateRangeSelect = document.getElementById("q_date_range");
    if (!dateRangeSelect) return;

    const isCustom = dateRangeSelect.value === "custom";
    const fromDate = document.getElementById("q_created_at_gteq");
    const toDate = document.getElementById("q_created_at_lteq");

    if (!isCustom) {
      // Clear date range fields if not custom
      if (fromDate) fromDate.value = "";
      if (toDate) toDate.value = "";

      // Remove required attribute
      if (fromDate) fromDate.required = false;
      if (toDate) toDate.required = false;
    } else {
      if (fromDate) fromDate.required = true;
      if (toDate) toDate.required = true;
    }

    if (this.hasCustomDateRangeFieldsTarget) {
      this.customDateRangeFieldsTarget.classList.toggle("hidden", !isCustom);
    }
  }

  // New method to handle form selection change
  sanitationFormChanged(event) {
    const formId = event.target.value;
    this.updateCustomFields(formId);
  }

  // Update custom fields based on selected form
  updateCustomFields(formId) {
    if (!this.hasFieldSelectTarget) return;

    // Get the currently selected field from URL params
    const urlParams = new URLSearchParams(window.location.search);
    const selectedFieldIds = urlParams.getAll("selected_fields[]");

    // Clear current selection
    this.fieldSelectTarget.innerHTML = "";

    // Add blank option
    const blankOption = document.createElement("option");
    blankOption.value = "";
    blankOption.textContent = "Escoge una opción";
    this.fieldSelectTarget.appendChild(blankOption);

    if (formId && this.allCustomFieldsValue) {
      // Get fields for this form
      const formFields = this.allCustomFieldsValue[formId] || [];

      // Add field options
      formFields.forEach((field) => {
        const option = document.createElement("option");
        option.value = field.id;
        option.textContent = `${field.name}`;

        // Set selected if this was the previously selected field
        if (selectedFieldIds.includes(field.id.toString())) {
          option.selected = true;
        }

        this.fieldSelectTarget.appendChild(option);
      });

      // Enable the field select
      this.fieldSelectTarget.disabled = false;
    } else {
      // If no form selected, disable the field select
      this.fieldSelectTarget.disabled = true;
    }
  }
}
